var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSou8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -652.362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.372,
    cy: 679.605,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.205,
    cy: 822.877,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.507,
    cy: 745.216,
    rx: 31.447,
    ry: 24.334,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.154,
    cy: 679.605,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.309 812.343V683.17",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 52.75361252,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.309,
    cy: 682.585,
    rx: 8.625,
    ry: 8.342,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.607 743.873 63.175-.06",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 34.7848587,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.324 780.515 70.302 767.61",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 46.37981033,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.184 814.606 104.461-86.352",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 45,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.681,
    cy: 679.605,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.463,
    cy: 679.605,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.514,
    cy: 822.877,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.618 812.343V683.17",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 52.75361252,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.618,
    cy: 682.585,
    rx: 8.625,
    ry: 8.342,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.019,
    cy: 822.877,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.562,
    cy: 745.216,
    rx: 31.447,
    ry: 24.334,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.816,
    cy: 745.216,
    rx: 31.447,
    ry: 24.334,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.618 684.686v36.297m0 51.791v44.825",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.644 757.672c4.055-6.177 14.924-5.911 18.337 0m-18.337-17.539c4.055-6.178 14.924-5.912 18.337 0",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.627 743.873-63.175-.06",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 34.7848587,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.71,
    cy: 822.877,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.05 814.606-104.462-86.352",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 45,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.252,
    cy: 745.216,
    rx: 31.447,
    ry: 24.334,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.25,
    height: 74.041,
    x: 122.302,
    y: 708.359,
    rx: 1.946,
    ry: 2.768,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.505 764.144 6.983 6.833m14.007-17.701 13.383-10.623.05-14.823",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.91 780.515 50.022-12.906",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 46.37981033,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.309 684.686v36.297m-22.795 87.262-32.982-27.063m55.777-8.408v44.825",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.334 757.672c4.056-6.177 14.925-5.911 18.338 0m-18.338-17.539c4.056-6.178 14.925-5.912 18.338 0",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.653 764.069-6.833 6.982m38.585-9.333-13.506-10.82m-39.16 2.378-13.383-10.623-.05-14.823M69.72 808.245l32.982-27.063m-18.874-19.464 13.507-10.82",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 1052.412)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.372,
    cy: 679.605,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.205,
    cy: 822.877,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.507,
    cy: 745.216,
    rx: 31.447,
    ry: 24.334,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.154,
    cy: 679.605,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.309 812.343V683.17",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 52.75361252,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.309,
    cy: 682.585,
    rx: 8.625,
    ry: 8.342,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.607 743.873 63.175-.06",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 34.7848587,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.324 780.515 70.302 767.61",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 46.37981033,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.184 814.606 104.461-86.352",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 45,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.681,
    cy: 679.605,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.463,
    cy: 679.605,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.514,
    cy: 822.877,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.618 812.343V683.17",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 52.75361252,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.618,
    cy: 682.585,
    rx: 8.625,
    ry: 8.342,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.019,
    cy: 822.877,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.562,
    cy: 745.216,
    rx: 31.447,
    ry: 24.334,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.816,
    cy: 745.216,
    rx: 31.447,
    ry: 24.334,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.618 684.686v36.297m0 51.791v44.825",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.644 757.672c4.055-6.177 14.924-5.911 18.337 0m-18.337-17.539c4.055-6.178 14.924-5.912 18.337 0",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.627 743.873-63.175-.06",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 34.7848587,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.71,
    cy: 822.877,
    rx: 23.672,
    ry: 18.317,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.05 814.606-104.462-86.352",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 45,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.252,
    cy: 745.216,
    rx: 31.447,
    ry: 24.334,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.25,
    height: 74.041,
    x: 122.302,
    y: 708.359,
    rx: 1.946,
    ry: 2.768,
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.505 764.144 6.983 6.833m14.007-17.701 13.383-10.623.05-14.823",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.91 780.515 50.022-12.906",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#004900",
      strokeWidth: 46.37981033,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.309 684.686v36.297m-22.795 87.262-32.982-27.063m55.777-8.408v44.825",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.334 757.672c4.056-6.177 14.925-5.911 18.338 0m-18.338-17.539c4.056-6.178 14.925-5.912 18.338 0",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.653 764.069-6.833 6.982m38.585-9.333-13.506-10.82m-39.16 2.378-13.383-10.623-.05-14.823M69.72 808.245l32.982-27.063m-18.874-19.464 13.507-10.82",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSou8);
export default __webpack_public_path__ + "static/media/Sou8.99457fdf735ca50dcebf71af25bfc0b0.svg";
export { ForwardRef as ReactComponent };